module.exports = __webpack_public_path__ + "static/media/delete.358156ef.svg";